export type NonEmptyTuple<Value> = [Value, ...Value[]];

export function literalValues<const Shape extends Record<string, string>>(
  shape: Shape,
): NonEmptyTuple<Shape[keyof Shape]> {
  const values: Array<Shape[keyof Shape]> = [];
  for (const key in shape) {
    values.push(shape[key]);
  }
  const [first, ...rest] = values;
  if (first === undefined) {
    throw new Error("literalValues requires at least one entry");
  }
  return [first, ...rest];
}
